export const LocalStore = {
    getJwt: () => {
        return localStorage.getItem('jwt');
    },
    setJwt: (jwt: string) => {
        localStorage.setItem('jwt', jwt);
    }
}